/*    
<summary>
   This is the Pricing Menu Component which shows the Pricing Data.
   Developer: Mohammad Saquib Khan, Created Date:24-Jan-2024
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/
import React, { SyntheticEvent, useEffect, useState } from "react";
import "./pricing-menu.css";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../contexts/StoreProvider";
import { observer } from "mobx-react";
import "react-sliding-side-panel/lib/index.css";
import _, { cloneDeep } from "lodash";
import { formatMessage } from "../../translations/format-message";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import no_group from "../../assets/Images/svg/search-tenant.svg";
import toast from "react-hot-toast";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  ScriptableContext,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { Field, Form, Formik } from "formik";
import Label from "../../shared-components/Label/Label";
import FormikFormInput from "../../shared-components/FormikFormHandlers/FormikFormInput";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import { billingStatsIccidValidateSchema } from "../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { initialState as dailyPacketCountICCIDGraphState } from "../../core/initial-state/daily-packet-count-graph-state";
import CustomTooltip from "../../shared-components/Tooltip/tooltip";

const PricingMenu = (props: any) => {
  const {
    tenantStore,
    pricingMenuStore,
  } = useStore();
  const date = new Date();
  const { GetAllTenantsService, allTenantOptions, resetAllTenantList } = tenantStore;
  const { GetPricingMenuStatsService, pricingMenuStats, pricingMenuStatsState, allMonthOptions, allYearOptions, GetDailyMessageCountByICCID, resetAllIccidPacketCountData, GetCurrentMonthAllIccidsMessageCount, dailyPacketCountAllIccidGraphData, dailyPacketCountByICCIDGraphData, resetPacketCountData } = pricingMenuStore;
  const [isSearchActive, setIsSearchActive] = useState<boolean>(false);
  const [selectedTenant, setSelectedTenantId] = useState<number>(-1);
  const [selectedMonth, setSelectedMonthId] = useState<number>(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [selectedIccid, setSelectedIccid] = useState<string>("");
  const [lineChartData, setLineChartData] = useState(dailyPacketCountICCIDGraphState);
  const [lineChartDataAll, setLineChartDataAll] = useState(dailyPacketCountICCIDGraphState);
  const [searchedData, setSearchedData] = useState<any>({
    TenantId: -1,
    Year: -1,
    Month: -1
  });
  const [selectedMsgCountType, setSelectedMsgCountType] = useState<string>("0");

  const lineChartDays: any[] = dailyPacketCountByICCIDGraphData?.Data;
  const lineChartDaysAllIccid: any[] = dailyPacketCountAllIccidGraphData?.Data;
  const lineChartLabels: any[] = dailyPacketCountByICCIDGraphData?.Labels
  const lineChartLabelsAllIccid: any[] = dailyPacketCountAllIccidGraphData?.Labels

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    GetAllTenantsService();
    return (() => {
      resetAllTenantList();
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSearchActive == true && selectedMsgCountType == "0") {
      GetCurrentMonthAllIccidsMessageCount(searchedData.TenantId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMsgCountType]);

  useEffect(() => {
    if (selectedTenant != -1) {
      getSelectedTenantStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTenant]);

  useEffect(() => {
    if (isSearchActive == true && selectedMsgCountType == "1") {
      const lineChart = cloneDeep(lineChartData);
      lineChart.data.datasets[0].data = lineChartDays;
      lineChart.data.labels = lineChartLabels;
      setLineChartData(lineChart);
      resetAllIccidPacketCountData();
    }
  }, [dailyPacketCountByICCIDGraphData, selectedMsgCountType]);

  useEffect(() => {
    if (isSearchActive == true && selectedMsgCountType == "0") {
      const lineChart = cloneDeep(lineChartDataAll);
      lineChart.data.datasets[0].data = lineChartDaysAllIccid;
      lineChart.data.labels = lineChartLabelsAllIccid;
      setLineChartDataAll(lineChart);
      resetPacketCountData();
    }
  }, [dailyPacketCountAllIccidGraphData, selectedMsgCountType]);

  const onResetClearGraph = () => {
    const lineChart = dailyPacketCountICCIDGraphState;
    setLineChartData(lineChart);
    setLineChartDataAll(lineChart);
  }


  const onTenantChange = (event: any) => {
    // debugger
    if (event.target.value == "-1") reset();

    resetAllGraphReleatedThings();
    const selectedOption = event.target.value;
    setSelectedTenantId(selectedOption);
    GetCurrentMonthAllIccidsMessageCount(selectedOption);
  };

  const resetAllGraphReleatedThings = () => {
    setSelectedIccid("");
    resetPacketCountData();
    resetAllIccidPacketCountData();
    setIsSearchActive(false);
    onResetClearGraph();
  }

  const onMonthChange = (event: any) => {
    const selectedOption = event.target.value;
    setSelectedMonthId(selectedOption);
  };

  const onYearChange = (event: any) => {
    const selectedOption = event.target.value;
    setSelectedYear(selectedOption);
  };

  const callPricingMenuService = () => {
    if (selectedTenant != -1 && selectedMonth != -1 && selectedYear != -1) {
      GetPricingMenuStatsService(
        selectedTenant,
        selectedMonth,
        selectedYear
      );
    }
  }


  const handleRadioChange = (value: string) => {
    setSelectedMsgCountType(value);
  };



  const getSelectedTenantStats = () => {
    if (selectedMonth > date.getMonth() + 1 && selectedYear >= date.getFullYear()) {
      toast.error(formatMessage("bill_month_year_validation"));
    } else {
      callPricingMenuService();
      setSearchedData({
        TenantId: selectedTenant,
        Year: selectedYear,
        Month: selectedMonth
      })
      setIsSearchActive(true);
    }
  }

  const reset = () => {
    setSelectedMonthId(-1);
    setSelectedYear(-1);
    setSelectedTenantId(-1);
    setSelectedIccid("");
    resetPacketCountData();
    resetAllIccidPacketCountData();
    setIsSearchActive(false);
    onResetClearGraph();
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement, Tooltip, Legend, Filler
  );

  return (
    <React.Fragment>
      {pricingMenuStatsState.inProgress && (
        <FormLoader loading={pricingMenuStatsState.inProgress} />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar BillingTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area">
                  <ul className="d-flex align-items-center">
                    <li>
                      <p className="h5 ps-5 mb-0">
                        <FormattedMessage id="pricing_menu_title" />
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto">
        <div className="pricingWrapper">
          <div className="row ">
            <div className="col-12">
              <div className="mb-2">
                <label className="">
                  <FormattedMessage id={"select_tenant"} />
                </label>
                <select
                  data-testid="tenantSelect"
                  className="form-control"
                  onChange={onTenantChange}
                  value={selectedTenant}
                >
                  {allTenantOptions.map((op: any) => (
                    <option key={op.value} value={op.id}>
                      {formatMessage(op?.value)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-12 col-xl-5 col-12">
              <div className="card">
                <div className="card-header px-2">
                  <div className="row align-items-end g-2">
                    <div className="col-12 col-xl-4 col-lg-5 col-md-4 col-sm-6 form-group">
                      <label className="">
                        <FormattedMessage id={"year"} />
                      </label>
                      <select
                        data-testid="tenantSelect"
                        className="form-control"
                        onChange={onYearChange}
                        value={selectedYear}
                      >
                        {allYearOptions.map((op: any) => (
                          <option key={op.value} value={op.id}>
                            {formatMessage(op?.value)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-xl-4 col-lg-5 col-md-4 col-sm-6 form-group">
                      <label className="">
                        <FormattedMessage id={"month"} />
                      </label>
                      <select
                        data-testid="tenantSelect"
                        className="form-control"
                        disabled={selectedYear == -1 ? true : false}
                        onChange={onMonthChange}
                        value={selectedMonth}
                      >
                        {allMonthOptions.map((op: any) => (
                          <option key={op.value} value={op.id}>
                            {formatMessage(op?.value)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-4 col-lg-2 col-md-4 col-sm-6 form-group col-12">
                      <button className="btn btn-primary"
                        disabled={selectedTenant > 0 && selectedMonth > 0 && selectedYear > 0 ? false : true}
                        // disabled={true}
                        onClick={() => { getSelectedTenantStats() }}>
                        <FormattedMessage id="search" />
                      </button>
                      {/* <button className="btn btn-secondary px-2 ms-1"
                        onClick={() => { reset() }}
                      >
                        <svg id="fi_7794645" enable-background="new 0 0 24 24" fill="currentColor" height="20" viewBox="0 0 24 24" width="20" ><g><path d="m10 9h-5c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v4h4c.6 0 1 .4 1 1s-.4 1-1 1z"></path></g><g><path d="m12 21c-1.1 0-2.2-.2-3.2-.6-1.8-.7-3.3-1.9-4.4-3.5-.3-.5-.2-1.1.3-1.4s1.1-.2 1.4.3c.8 1.2 2 2.2 3.4 2.7s2.9.6 4.4.2c1.4-.4 2.7-1.3 3.6-2.5s1.4-2.6 1.5-4.1c0-1.5-.4-3-1.3-4.2s-2.1-2.1-3.5-2.6-2.9-.5-4.4 0c-1.4.5-2.6 1.4-3.5 2.6-.3.5-.9.6-1.4.3s-.6-1-.2-1.4c1.1-1.6 2.7-2.8 4.5-3.4s3.8-.6 5.6 0 3.4 1.8 4.5 3.4 1.7 3.4 1.6 5.4c0 1.9-.7 3.8-1.9 5.3s-2.8 2.6-4.7 3.2c-.6.2-1.5.3-2.3.3z"></path></g></svg>
                      </button> */}
                    </div>
                  </div>
                </div>
                <div className="p-3 scrolable-card">
                  {selectedTenant > 0 && selectedMonth > 0 && selectedYear > 0 && isSearchActive === true ? (
                    <>
                      <div className="row g-0 align-items-center">
                        <div className="col-12 border-bottom pb-2">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted">
                              <FormattedMessage id="active_device_count" /> <CustomTooltip id="active_device_count_info" message="active_device_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.TotalActiveDeviceCountAtLastDayOfMonth?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted">
                              <FormattedMessage id="total_device_count" /> <CustomTooltip id="total_device_count_info" message="total_device_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.TotalDeviceCountAtLastDayOfMonth?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted">
                              <FormattedMessage id="new_device_registration" />
                              <CustomTooltip id="total_message_count" message="new_device_registration_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.RegisteredDeviceCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted">
                              <FormattedMessage id="newly_active_device_count" />
                              <CustomTooltip id="total_message_count" message="newly_active_device_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.ActiveDeviceCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted"><FormattedMessage id="deleted_device_count" />
                              <CustomTooltip id="total_message_count" message="deleted_device_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.DeletedDeviceCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted"><FormattedMessage id="expose_api_request_count" />
                              <CustomTooltip id="total_message_count" message="expose_api_request_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.ExposeApiRequestCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted"><FormattedMessage id="total_message_count" />
                              <CustomTooltip id="total_message_count" message="total_message_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.TotalMessageCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 border-bottom py-1">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted"><FormattedMessage id="ul_message_count" />
                              <CustomTooltip id="total_message_count" message="ul_message_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.ULMessageCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                        <div className="col-12 py-2">
                          <div className="d-flex justify-content-between">
                            <p className="text-muted"><FormattedMessage id="dl_message_count" />
                              <CustomTooltip id="total_message_count" message="dl_message_count_info" />
                            </p>
                            <h3 className="mb-0">{pricingMenuStats?.DLMessageCount?.toLocaleString("en-US")}</h3>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center">
                      <img src={no_group} alt="" className="no_message" />
                      <p className="noData text-muted text-center h5 mb-0">
                        <FormattedMessage id="select_tenant_message" />
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-7 col-12">
              <div className="card card-body">
                <div className="DeviceLineWrap">
                  <div className="form-group mb-3">
                    <Formik
                      initialValues={{ ICCID: "", MessageCountType: selectedMsgCountType }}
                      validationSchema={billingStatsIccidValidateSchema}
                      enableReinitialize
                      validateOnBlur={false}
                      onSubmit={async (values: any) => {
                        GetDailyMessageCountByICCID(selectedTenant, values.ICCID);
                        setSelectedIccid(values?.ICCID);
                      }}
                    >
                      {({ values }) => {
                        return (
                          <Form id="formBody">
                            <div className="row g-0 align-items-center">
                              <div className="col-lg-6 col-12">
                                <div className="d-flex align-items-center">
                                  <label className="m-0">
                                    <FormattedMessage id="ul_message_count_label" />
                                  </label>
                                  <div className="btn-radioCheckbox ms-1">
                                    <Field
                                      type="radio"
                                      value="0"
                                      name="MessageCountType"
                                      id="all"
                                      onChange={() => handleRadioChange('0')}
                                      className="nav-link active"
                                    />
                                    <label htmlFor="all">
                                      <FormattedMessage id="all_iccid" />
                                    </label>
                                  </div>

                                  <div className="btn-radioCheckbox ms-1">
                                    <Field
                                      type="radio"
                                      value="1"
                                      name="MessageCountType"
                                      id="single"
                                      onChange={() => handleRadioChange('1')}
                                      className="nav-link active"
                                    />
                                    <label htmlFor="single">
                                      <FormattedMessage id="single_iccid" />
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* <Label
                                    className="label-style text-dark col-lg-4 col-xl-1 col-12"
                                    required={true}
                                    label="iccid"
                                  /> */}
                              {values?.MessageCountType == "1" &&
                                <>
                                  <div className="col-lg-6 col-12">
                                    <div className=" input-group">
                                      <Field
                                        data-testid="ICCID"
                                        className="form-control"
                                        name="ICCID"
                                        placeholder="iccid"
                                        type="number"
                                        as={FormikFormInput}
                                      />
                                      <LoaderButton
                                        isLoading={props.isLoading}
                                        type="submit"
                                        id={"SaveGroup"}
                                        text="submit"
                                      />
                                    </div>
                                  </div>

                                </>
                              }
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                  <div className="DeviceLineChart">
                    {selectedMsgCountType == "1" ?
                      <Line data={lineChartData?.data} options={lineChartData?.options} />
                      :
                      <Line data={lineChartDataAll?.data} options={lineChartDataAll?.options} />
                    }

                    {selectedIccid != "" && selectedMsgCountType == "1" ? <div className="text-center"><p className="text-muted"><FormattedMessage id="iccid" /> :  <span>{selectedIccid}</span></p></div> : ""}
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

    </React.Fragment>
  );
};

export default observer(PricingMenu);
